<template>
  <CockpitDialog
    :title="`${carSource === 'inner' ? '内部' : '外协'}车辆列表`"
    @close="closeCarList"
    :top="'200px'"
    :left="'400px'"
    :width="'1000px'"
    :height="'600px'"
  >
    <div class="w-full h-full relative">
      <div class="flex mb-20px mr-10px">
        <el-input
          v-model="searchForm.keyWord"
          size="small"
          class="mr-10px !w-50"
          placeholder="车牌号"
          clearable
        ></el-input>
        <el-date-picker
          class="mr-10px w-300px"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="searchForm.searchTime"
          popper-class="visualization-picker-popper"
          clearable
        ></el-date-picker>
        <el-button size="small" type="primary" @click="handleSearch">查询</el-button>
        <el-button size="small" type="primary" @click="reset">重置</el-button>
      </div>
      <el-table
        :data="carList"
        border
        class="w-full"
        height="calc(100% - 110px)"
        v-loading="carLoading"
      >
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="车牌号" prop="carNumber" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="设备名称" prop="deviceName" show-overflow-tooltip></el-table-column>
        <el-table-column label="设备编码" prop="deviceCode" show-overflow-tooltip></el-table-column>
        <el-table-column label="动作" prop="actionType" width="100">
          <template slot-scope="{ row }">
            {{ row.actionType === 1 ? '进入' : '离开' }}
          </template></el-table-column
        >
        <el-table-column label="动作时间" min-width="125px" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span>{{ row.time ? dayjs(row.time).format('YYYY-MM-DD HH:mm:ss') : row.time }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="getCarList"
        @size-change="handleSearch"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        class="flex justify-center mt-20px ml-10px"
        popper-class="visualization-select-popper"
      ></el-pagination>
    </div>
  </CockpitDialog>
</template>

<script>
import dayjs from 'dayjs'
import { isNil, get, find, isEmpty, omit, head, map } from 'lodash'
import { PersonnelLocationApi } from '@wiz-api/huizhou2'

const personnelLocationApi = new PersonnelLocationApi()

const CockpitDialog = () => {
  return import('@/components/cockpit/CockpitDialog')
}
export default {
  components: {
    CockpitDialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 车辆来源（内部、外部）
    carSource: {
      type: String,
      // 默认内部车辆
      default: 'inner',
    },
  },
  data() {
    return {
      searchForm: {
        keyWord: '',
        searchTime: '',
      },
      carList: [], // 车辆列表
      carLoading: false,
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      carSourceMap: {
        inner: 1,
        outside: 2,
      },
    }
  },
  async created() {
    this.searchForm.searchTime = [
      dayjs()
        .startOf('date')
        .format('YYYY-MM-DD HH:mm:ss'),
      dayjs()
        .endOf('date')
        .format('YYYY-MM-DD HH:mm:ss'),
    ]
    await this.getCarList()
  },
  methods: {
    // 获取车辆列表
    async getCarList() {
      this.carLoading = true
      const [err, res] = await personnelLocationApi.getCarRealtimeRecord({
        body: {
          type: this.carSourceMap[this.carSource],
          keyWord: this.searchForm.keyWord,
          startTime: this.searchForm.searchTime ? this.searchForm.searchTime[0] : null,
          endTime: this.searchForm.searchTime ? this.searchForm.searchTime[1] : null,
          maxResultCount: this.page.pageSize,
          skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        },
      })
      if (!err && !isNil(res)) {
        this.carList = res.items
        this.page.total = res.totalCount
      }
      this.carLoading = false
    },
    // 搜索
    async handleSearch() {
      this.page.pageNo = 1
      await this.getCarList()
    },
    // 重置搜索表单
    reset() {
      this.searchForm = this.$options.data().searchForm
      this.searchForm.searchTime = [
        dayjs()
          .startOf('date')
          .format('YYYY-MM-DD HH:mm:ss'),
        dayjs()
          .endOf('date')
          .format('YYYY-MM-DD HH:mm:ss'),
      ]
      this.handleSearch()
    },
    closeCarList() {
      this.$emit('update:visible', false)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-loading-mask {
  background: linear-gradient(180deg, rgb(8 34 57 / 90%) 0%, rgba(3, 25, 43, 0.9) 93.96%);
}
</style>
